<div class="SLV2-main-wrapper" >
  <div class="row hdr-back-row" style="display:none;">
    <div class="col-12 back-btn-col">
      <button (click)="goBack()" type="button" class="btn btn-outline-secondary mt-3 mb-3 video-back-btn">
        <img class="ml-0mr-2 bck-icn" src="assets/img/back-arrow-icon-dark.svg" alt=""> GO BACK
      </button>
    </div>
  </div>

  <div class="UNAPP-yt-video-cht-section" #chatcolCollaps>
    <div class="UNAPP-yt-video-col">
      <div class="UNAPP-yt-btn-group desk-view">
        <button class="UNAPP-yt-back-btn" (click)="goBack()"><img class="ml-0mr-2 bck-icn"
            src="assets/img/back-button.svg" alt=""> GO BACK</button>
        <!-- <button *ngIf="showFullScreenIconAndFeedBackPopup" class="UNAPP-yt-fullscreen-btn sm" (click)="showFullScreen()"><img src="assets/img/fullscreen-icon.svg" /></button> -->
      </div>
      
      <div class="video-iframe-box">
        <div class="UNAPP-yt-btn-group d-hide">
          <button class="UNAPP-yt-back-btn mobview" (click)="goBack()"><img class="ml-0mr-2 bck-icn" src="assets/img/back-button.svg" alt=""> GO BACK</button>
        </div>
        <!-- *ngIf="showFullScreenIconAndFeedBackPopup" -->
        <button *ngIf="!videoFullscreenStatus" class="UNAPP-yt-fullscreen-btn sm" (click)="showFullScreen()"><img src="assets/img/fullscreen-icon-2.svg" /></button>

        <div class="UNAPP-yt-best-screen-overlay" [ngClass]="{'hide':!videoLandscapeSatatus}">
          <span>Best viewed in landscape</span>
          <img src="assets/img/mobile-landscape-icon.svg" />
        </div>
<!-- 
        <button class="UNAPP-yt-fullscreen-btn"><img src="assets/img/fullscreen-icon.svg" /></button> -->

        <div id="video-iframe-container" class="video-iframe-container" [ngClass]="{'fullscreenMode':videoFullscreenStatus}" (dblclick)="divdblClick($event)" (click)="divClick($event)">
          <span class="yt-logo-overlay"></span>
          <iframe id="iframe-id" [src]="urlSafe" allow="autoplay" donotallowfullscreen></iframe>
          <div #videocontainer id="videocontainer">
            <button class="UNAPP-yt-fullscreen-btn exitFullScreen sm" *ngIf="videoFullscreenStatus" (click)="exitFullScreen()"><img class="ml-0mr-2 bck-icn" src="assets/img/fullscreen-exit-icon.svg" alt=""></button>
            <!-- <button *ngIf="showFullScreenIconAndFeedBackPopup" class="UNAPP-yt-fullscreen-btn sm" (click)="exitFullScreen()"><img src="assets/img/fullscreen-exit-icon.svg" /></button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="UNAPP-yt-chat-col">
      <button class="UNAPP-yt-chat-icon active"><img src="assets/img/chat-blue-line-icon.svg" /></button>
      <ng-container *ngIf="!chatTextareaFocused">
        <button class="UNAPP-yt-chat-hide-btn" id="chatArrow" #chatArrow (click)="chatcolCollaps.classList.toggle('collaps')"><img src="assets/img/collaspe-arrow-dark.svg" /></button>
      </ng-container>
      <div class="UNAPP-yt-chat-hdr"><span class="UNAPP-yt-chat-hdr-title">Chats</span></div>
      <div #scrollContainer class="UNAPP-yt-chat-list-row">
        <ul class="UNAPP-yt-chat-list">
          <li class="UNAPP-yt-no-chat" *ngIf="messageHistory.length == 0">
            <img src="assets/img/chat-conversation-icon.svg"/>
            <ng-container *ngIf="!chatTextareaDisabled">
              <div class="welcome-text">Welcome!</div>
              <div class="say-hello">Say Hello and get started</div>
            </ng-container>
        </li>
          <li *ngFor="let message of messageHistory">
            <div class="UNAPP-yt-chat-box" [ngClass]="{'you':message.fromUser.userName == userService.getMobileAndName().firstName+' '+userService.getMobileAndName().lastName, 'teacher':message.fromUser.role == '1'}">
              <div class="UNAPP-yt-chat-title-row">
                  <div class='dp-box'>
                    <img src="assets/img/blue-teacher-icon.svg" class="teacher-icon" />              
                    <img src="assets/img/blue-star-icon.svg" class="icon-blue-star-icon" />              
                  </div>
                <div class="UNAPP-yt-chat-title-wrap">{{message?.fromUser?.userName}}</div><span class="dot">•</span><span class="UNAPP-yt-chat-time">{{getTime(message?.sendTime)}}</span>
              </div>
              <div class="UNAPP-yt-chat-msg-wrap">
                <div>{{message?.message}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="UNAPP-yt-chat-input-row" *ngIf="!chatTextareaDisabled" [ngClass]="{'chatTextareaFocused':chatTextareaFocused}">
        <div class="UNAPP-yt-chat-input-box">
          <div class="UNAPP-yt-chat-emoji-row" >
            <img (click)="appendEmoji('👍')" src="assets/img/emoji/like.png" />
            <img (click)="appendEmoji('👎')" src="assets/img/emoji/dislike.png" />
            <img (click)="appendEmoji('👏')" src="assets/img/emoji/clap.png" />
            <img (click)="appendEmoji('😄')" src="assets/img/emoji/smaile.png" />
            <img (click)="appendEmoji('😔')" src="assets/img/emoji/sad.png" />
          </div>
           <div class="UNAPP-yt-usrinput-row">
            <div class="UNAPP-yt-usrinput-col"><textarea #messageText  id="messageText" placeholder="Type Here..." (click)="focusFunction()"></textarea></div>
            <button class="UNAPP-yt-reply-btn" [disabled]="messageText.value.length === 0" (click)="sendMessage(messageText.value,false)"><img src="assets/img/emoji/reply-icon.svg" /></button>
          </div>
        </div>
      </div>
      <div class="UNAPP-yt-chat-bg-overlay" (click)="focusOutFunction()"></div>
    </div>
  </div>
</div>